import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class WorkShopService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getListData(PageIndex: number = 1, PageSise: number = 10) {
    const url = environment.BASE_API_URL + CONSTANTS.API.WORK_SHOP.LIST;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { pageSize: PageSise.toString(), page: PageIndex.toString() },
    });
  }
}
